import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { refundQueryOptions } from '../../../../features/refunds/queries'

export const Route = createFileRoute('/_app/refunds/$refundId')({
  staticData: { crumb: 'refund' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  loader: ({ context, params }) => context.queryClient.ensureQueryData(refundQueryOptions(params.refundId)),
  component: Outlet,
})
